import { LazyImage } from '@components/common/image'
import BookTrialClassContainer from '@containers/book-trial-class/book-trial-class-container'
import { decode } from '@lib/utils/base64'
import { useRouter } from 'next/router'

const FirstFold = () => {
  const router = useRouter()
  const name = decode(router.query.referrer as string)
  return (
    <div className="container mx-auto pb-8 lg:bg-white mt-10 px-3 flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 px-3 lg:px-0">
        <p className="text-3xl lg:text-4xl leading-9 text-center lg:text-left">
          <span className="font-600 capitalize">{name || 'Your friend'}</span>{' '}
          invited you to learn coding with Codingal at{' '}
          <span className="font-600 text-orange">20% discount</span>
        </p>

        <LazyImage
          className="mt-6 d-none lg:d-block"
          path="/images/referral-page/"
          alt="cover-imgae"
          name="coverImage"
        />
      </div>
      <div className="w-full lg:w-1/2 lg:px-12">
        <BookTrialClassContainer cta="Register for free" />
      </div>
    </div>
  )
}

export default FirstFold
